// Module
var code = " <div class=\"flex-row flex-cross-start\"> <gh-thumbnail class=\"mr-15\" [source]=\"form.pictureSlot?.item\"></gh-thumbnail> <gh-single-uploader [ghUploadSlot]=\"form.pictureSlot\" [disabled]=\"form.viewMode\" (invalid)=\"onFileInvalid($event)\" accept=\"image/png,image/jpeg,image/jpg\" maxSize=\"5mb\"></gh-single-uploader> </div> ";
// Exports
module.exports = code;